import { Component, ElementRef, HostListener, input, OnInit, output, inject } from '@angular/core';
import {
    AixButtonComponent,
    AixDataTestingDirective,
    BUTTON_TYPE
} from '@trade-platform/ui-components';

export interface AixProductCardButtonOption {
    label: string;
    value: string;
}

@Component({
    selector: 'aix-product-card-begin-button',
    templateUrl: 'product-card-begin-button.html',
    styleUrls: ['product-card-begin-button.scss'],
    imports: [AixDataTestingDirective, AixButtonComponent],
    standalone: true
})
export class AixProductCardBeginButtonComponent implements OnInit {
    private ref = inject(ElementRef);

    label = input.required<string>();
    options = input.required<AixProductCardButtonOption[]>();

    selectedOption: AixProductCardButtonOption;
    isOpen = false;
    linkButtonType = BUTTON_TYPE.link;

    optionSelected = output<AixProductCardButtonOption>();

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    ngOnInit() {
        this.selectedOption = this.options()[0];
    }

    optionClicked(option: AixProductCardButtonOption) {
        this.selectedOption = option;
        this.optionSelected.emit(option);
    }

    @HostListener('document:click', ['$event'])
    onClickOutside($event: MouseEvent) {
        if (!this.ref.nativeElement.contains($event.target)) {
            this.isOpen = false;
        }
    }
}
